<template>
  <div class="mediaPlayer">
    <GalleryModule
      :class="{'hidden' : !hasGallery}"
      ref="galleryModule"
    />
    <AudioModule
      :class="{'hidden' : !hasAudio && !hasGalleryAudio}"
      :minimalInterface="audioPlayerMinimal"
      ref="audioModule"
    />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout } from 'timers';
import AudioModule from './AudioModule.vue';
import GalleryModule from './GalleryModule.vue';

export default {
  name: 'mediaPlayer',
  components: {
    AudioModule,
    GalleryModule,
  },
  data() {
    return {
      active: false,
      playerProgress: 0,
    };
  },
  computed: {
    ...mapGetters(['currentExhibit', 'currentPlayerGallery', 'currentGalleryItem', 'currentPlayerAudio', 'playerActive', 'playerAudioActive']),
    isActive() {
      return this.playerActive;
    },
    hasExhibit() {
      return !(!this.currentExhibit);
    },
    hasImages() {
      return this.isActive
      && this.hasExhibit
      && !(!this.currentExhibit.images)
      && !(!this.currentExhibit.images[0]);
    },
    hasAudio() {
      return this.isActive && this.hasExhibit && !(!this.currentExhibit.audio);
    },
    hasGallery() {
      return this.isActive && this.hasExhibit && !(!this.currentExhibit.gallery);
    },
    hasGalleryAudio() {
      return this.hasGallery && !(!this.currentGalleryItem);
    },
    isPlaying() {
      return this.playerAudioActive || this.hasGallery;
    },
    audioPlayerMinimal() {
      return !(!this.currentPlayerGallery);
    },
  },
  methods: {
    ...mapActions(['setExhibit', 'setPlayerGallery', 'setPlayerGalleryItem', 'setPlayerAudio', 'setPlayerImages', 'setPlayerDescription', 'setPlayerActive', 'setPlayerAudioActive']),
    initPlayer() {
      // this.setPlayerActive(true);

      if (this.hasImages) {
        this.setPlayerImages(this.currentExhibit.images);
      }
      if (this.hasAudio) {
        this.setPlayerAudio(this.currentExhibit.audio);
        this.setPlayerDescription(this.currentExhibit.description);
        this.setPlayerAudioActive(true);
      }
      if (this.hasGallery) {
        this.setPlayerGallery(this.currentExhibit.gallery);
      }
      if (process.env.VUE_APP_DEBUG === 'on') console.log(' from MediaPlayer initPlayer');
    },
    closePlayer() {
      // close player
      if (this.playerActive) {
        this.setPlayerActive(false);
      }
      if (this.currentGalleryItem !== null) {
        this.setPlayerGalleryItem(null);
      }
      // stop players
      if (this.playerAudioActive) {
        this.setPlayerAudioActive(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from MediaPlayer closePlayer');
      }

      // clear player data
      setTimeout(() => {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Clear MediaPlayer');

        this.setPlayerImages(null);
        this.setPlayerAudio(null);
        this.setPlayerDescription(null);
        this.setPlayerGallery(null);
        if (this.currentExhibit !== null) {
          this.setExhibit(null);
        }
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from MediaPlayer closePlayer');
      }, 500);
    },
  },
  watch: {
    /* hasExhibit(newValue) { // mediaPlayer opens when exhibit is set
      if (newValue) {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Open MediaPlayer - New Exhibit');
        this.initPlayer();
      }
    }, */
    isPlaying(newValue) { // when finished playing
      if (!newValue && this.isActive) {
        this.setPlayerActive(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Deactivate MediaPlayer - Finished Playing');
      }
    },
    isActive(newValue) { // when player is closed
      if (newValue) {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Open MediaPlayer');
        this.initPlayer();
      } else if (!this.hasGallery) {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Close MediaPlayer');
        this.closePlayer();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mediaPlayer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 0;
  box-sizing: border-box;
  overflow: visible;
  color: var(--main-text-color);
  /* font-size: .9em; */
}
@media only screen and (orientation : portrait)
 and (min-aspect-ratio: 4/9)
 and (max-height : 700px) {
  .mediaPlayer{
    font-size: .9em;
  }
}
</style>
